import { createQuery } from "react-query-kit";
import ZoneCounterModel from "../../models/transaction/zonecounter-model";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import axios, { AxiosError } from "axios";
import { API_END_POINT } from "../../constants";
import ProductInvoiceHistoryModel from "../../models/transaction/productinvoicehistory-model";


const url = getEndPoint(API_END_POINT.ORDER) + "/api/OrderMain/GetAllZone";
export const useGetZoneCounterList = createQuery<
    ZoneCounterModel[],
    null,
    AxiosError
>({
    queryKey: ["keyZoneCounterlist"],
    fetcher: (params) =>
        getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
        // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
    refetchOnWindowFocus: false,
});



const productnvurl = getEndPoint(API_END_POINT.ORDER) + "/api/OrderMain/GetAllZone";
export const useGetZoneCounterListforProductInv = createQuery<
ProductInvoiceHistoryModel[],
    null,
    AxiosError
>({
    queryKey: ["keyZoneCounterlistforProductInv"],
    fetcher: (params) =>
        getDataWithToken<any>(productnvurl).then((response) => response.data?.result || console.log(response)),
        // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
    refetchOnWindowFocus: false,
});